export default "__VITE_ASSET__BGkCaGpW__"